/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var parsleyUtil = require('common/util/parsleyUtil');

var tmplConSerComplaintFormYourInformationView = require('../templates/ConSerComplaintFormYourInformationView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerComplaintFormYourInformationView,

  className: 'conser-complaint-form-your-information-view',

  ui: {
    isConsumer: 'input[name="isConsumer"]',
    isConsumerNoRadio: 'input[name="isConsumer"][value="0"]',
    isConsumerInfoForm: '.is-not-consumer-form',
    complaintantInformationForm: '.complaintant-information-form'
  },

  events: {
    'change @ui.isConsumer': 'onChangeIsConsumer'
  },

  behaviors: {
    RadioGroupToggleBehavior: {
      radios: function() {
        var radios = [
          {
            target: '.is-not-consumer-form',
            radioGroup: '[name="isConsumer"]',
            valueToShow: '0'
          }
        ];

        return radios;
      }
    },
    PhoneFormatBehavior: {}
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.toJSON());
  },

  validate: function(config) {
    this.ui.complaintantInformationForm.parsley().reset();

    if (config.type === 'save') {
      // // Turn off required field validation for these forms
      parsleyUtil.disableRequiredValidation(this.ui.complaintantInformationForm);
      parsleyUtil.disableRequiredValidation(this.ui.isConsumerInfoForm);
    } else {
      // // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.complaintantInformationForm);
      parsleyUtil.enableRequiredValidation(this.ui.isConsumerInfoForm);
    }
    var formData = Syphon.serialize(this.ui.complaintantInformationForm);
    var isConsumer = formData.isConsumer === '1';
    var validationPromises = [this.ui.complaintantInformationForm.parsley().whenValidate()];
    if (!isConsumer) {
      validationPromises.push(this.ui.isConsumerInfoForm.parsley().whenValidate());
    }

    return $.when.apply($, validationPromises);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    return formData;
  }
});
